import { Helmet } from "react-helmet-async";

function getMetaFromSlug(slug = "") {
  switch (slug) {
    case "12 Grundprinzipien Animation":
      return {
        title: "12 Grundprinzipien der Animation",
        description: "Entdecke die 12 Grundprinzipien der Animation und wie sie deine Projekte zum Leben erwecken.",
        image: "https://www.denisbitter.de/images/blog/12prinzipien_sketch_m.webp",
        url: `https://www.denisbitter.de/post/${slug}`,
        type: "BlogPosting",
      };

    case "kompass":
      return {
        title: "Kompass – Dein Weg zu klarem Lernen",
        description: "Persönliche Orientierung im digitalen Bildungsdschungel.",
        image: "https://www.denisbitter.de/images/kompass1.svg",
        url: `https://www.denisbitter.de/post/${slug}`,
        type: "BlogPosting",
      };
    default:
      return {
        title: "Denis Bitter — software fullstack architect",
        description: "Digitale Bildung mit Haltung. Klar. Authentisch. Persönlich.",
        image: "https://www.denisbitter.de/images/default.jpg",
        url: `https://www.denisbitter.de/post/${slug}`,
        type: "WebPage",
      };
  }
}

export default function SeoHelmet({ slug, title, description, keywords, ogImage, image, url, type }) {
  if (typeof window !== "undefined" && window.location.hostname === "localhost") return null;

  const meta = slug ? getMetaFromSlug(slug) : null;
  const resolvedTitle = title || (meta && meta.title);
  const resolvedDescription = description || (meta && meta.description);
  const resolvedUrl = url || (meta && meta.url);
  const resolvedImage = ogImage || image || (meta && meta.image);
  const resolvedType = type || (meta && meta.type) || "WebPage";

  if (!resolvedTitle || !resolvedDescription) return null;

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": resolvedType,
    "headline": resolvedTitle,
    "description": resolvedDescription,
    "image": resolvedImage,
    "url": resolvedUrl,
    "datePublished": "2024-01-01", // optional: dynamisch erweitern
    "author": {
      "@type": "Person",
      "name": "Denis Bitter"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Denis Bitter",
      "logo": {
        "@type": "ImageObject",
        "url": "https://www.denisbitter.de/b_gray.png"
      }
    }
  };

  return (
    <Helmet>
      <title>{resolvedTitle}</title>
      <meta name="description" content={resolvedDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta property="og:title" content={resolvedTitle} />
      <meta property="og:description" content={resolvedDescription} />
      <meta property="og:type" content={resolvedType === "BlogPosting" ? "article" : "website"} />
      {resolvedUrl && <meta property="og:url" content={resolvedUrl} />}
      {resolvedImage && <meta property="og:image" content={resolvedImage} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={resolvedTitle} />
      <meta name="twitter:description" content={resolvedDescription} />
      {resolvedImage && <meta name="twitter:image" content={resolvedImage} />}
      {resolvedUrl && <link rel="canonical" href={resolvedUrl} />}

      {/* 🧠 STRUCTURED DATA */}
      <script type="application/ld+json">
        {JSON.stringify(jsonLd)}
      </script>
    </Helmet>
  );
}
